module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Small_Text.4c1d44c2.svg";